import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetRemoteLockDevicesRequest = {
  buildingId: number
}

export type RemoteLockLock = {
  id: string
  name: string
}

export const getRemoteLockDevicesQueryKey = (data: GetRemoteLockDevicesRequest) => [
  'useGetRemoteLockDevices',
  data,
]

const getRemoteLockDevices = async (data: GetRemoteLockDevicesRequest) => {
  const response = await authAPI.get<RemoteLockLock[]>('/remote-lock/locks', {
    params: { buildingId: data.buildingId },
  })
  return response.data
}

export const useGetRemoteLockDevices = (data: GetRemoteLockDevicesRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getRemoteLockDevices(data),
    queryKey: getRemoteLockDevicesQueryKey(data),
  })
